// extracted by mini-css-extract-plugin
export default {"root":"InputContent_root__yBWhA","align-center":"InputContent_align-center__9uZx7","align-end":"InputContent_align-end__Drxjd","align-start":"InputContent_align-start__nigqt"};